export * from "./demo-notifications.contract";

import {
  demoNotificationsContracts,
  demoSeedingContracts,
} from "./demo-notifications.contract";

export const demoContracts = {
  notifications: demoNotificationsContracts,
  seeding: demoSeedingContracts,
} as const;
